import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { ConfigService } from '@fcom/core';
import { ProfileTier } from '@fcom/core-api/login';
import { LocalDate, pad } from '@fcom/core/utils';

import { FlightListSegment, AmadeusError } from '../interfaces/upgrade-availability.interface';

enum ErrorCode {
  TIMEOUT = '3001',
  SAMELOCATION = '10001',
  NOTFOUND = '9100',
}

@Injectable()
export class UpgradeAvailabilityService {
  private officeId = {
    GOLD: 'HELAY08FG',
    PLATINUM: 'HELAY08FP',
    LUMO: 'HELAY08FL',
  };

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {}

  getUpgradeAvailability(
    tier: ProfileTier,
    departure: string,
    destination: string,
    departureDate: LocalDate,
    country: string,
    language: string
  ): Observable<FlightListSegment[] | AmadeusError> {
    const officeId = this.officeId[tier.toUpperCase()] ? this.officeId[tier.toUpperCase()] : 'HELAY08AA';
    const error = {
      code: '',
      message: 'LOYALTY.upgradeAvailability.error.generic',
    };
    const apiUrl = this.configService.cfg.upgradeAvailabilityUrl;
    const params: HttpParams = new HttpParams()
      .set('SO_SITE_OFFICE_ID', officeId)
      .set('COUNTRY_SITE', country)
      .set('SITE', 'FINRFINR')
      .set('LANGUAGE', language)
      .set('PAGE', 'UPGD')
      .set('B_LOCATION_1', departure)
      .set('E_LOCATION_1', destination)
      .set('B_DATE_1', this.formatDate(departureDate))
      .set('EMBEDDED_TRANSACTION', 'AirAvailability')
      .set('WDS_RBD_CATALOG', '1');
    return this.httpClient.get(`${apiUrl}/`, { params }).pipe(
      map((response: any) => {
        // eslint-disable-next-line camelcase
        if (response?.avail?.list_flight) {
          return JSON.parse(JSON.stringify(response.avail.list_flight));
        } else {
          const code = response.ERROR[0].code;
          if (code === ErrorCode.TIMEOUT) {
            error.message = 'LOYALTY.upgradeAvailability.error.timeout';
          } else if (code === ErrorCode.SAMELOCATION) {
            error.message = 'LOYALTY.upgradeAvailability.error.sameLocations';
          } else if (code === ErrorCode.NOTFOUND) {
            error.message = 'LOYALTY.upgradeAvailability.error.notFound';
          }
          error.code = code;
          return error;
        }
      }),
      // eslint-disable-next-line rxjs/no-implicit-any-catch
      catchError((err) => {
        if (err.status === 504 || err.status === 408) {
          error.message = 'LOYALTY.upgradeAvailability.error.timeout';
        }
        error.code = err.status.toString();
        return of(error);
      })
    );
  }

  private formatDate(date: LocalDate): string {
    return `${date.localYear}${pad(date.localMonth)}${pad(date.localDay)}0000`;
  }
}
